import React from 'react';
import PropTypes from 'prop-types';

import { AppStateContext } from 'src/stores';
import UserService from 'src/services/user';
import withRouter from 'src/components/withRouter';
import { Router } from 'src/constants';

const withProfile = (WrappedComponent, isRequired = true, isAdmin = false) => {
  class WithProfileHOC extends React.Component {
    static propTypes = {
      router: PropTypes.object.isRequired,
      forwardedRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
      ])
    };

    async componentDidMount() {
      const { actions } = this.context ?? {};

      try {
        const p = await UserService.profile();
        actions.updateProfile(p);

        if (isAdmin && !p.isAdmin) {
          this.props.router?.navigate(Router.Client.Home);
        }

      } catch (err) {
        actions.updateProfile(null);
        UserService.logout();

        if (isRequired) {
          this.props.router?.navigate(Router.Auth.Login);
        }
      }
    }

    render() {
      const {
        forwardedRef = null,
        router,
        ...ps
      } = this.props;

      return isRequired && !this.context.state.profile ? null : (
        <WrappedComponent
          {...ps}
          profile={this.context.state.profile}
          router={router}
          ref={forwardedRef}
        />
      );
    }
  }

  WithProfileHOC.contextType = AppStateContext;

  const Component = withRouter(WithProfileHOC);

  return React.forwardRef((props, ref) => {
    return <Component {...props} forwardedRef={ref} />;
  });
};

export default withProfile;
